export class ForbiddenError extends Error { }

export class InvalidParameter extends Error { }

export class InvalidCreationException extends Error { }

export class InvalidUpdateOperationException extends Error { }

export class PropertyNotAvailableException extends Error { }

export class NoActiveSubscription extends Error {
    constructor(...args) {
        super(...args);
        this.message = "No active subscription";
    }
}

export class AuthException extends Error {}